export class FetchErrorResponse {
  status: number
  body: Record<string, unknown>

  constructor({ status, body }: { status: number; body: Record<string, unknown> }) {
    this.status = status
    this.body = body
  }
}

export async function fetchJson<T extends Record<string, unknown>>(
  method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE',
  baseUrl: string,
  content?: {
    body?: Record<string, unknown>
    headers?: Record<string, string>
    query?: Record<string, string>
  }
): Promise<T> {
  try {
    let url = baseUrl
    if (content?.query) {
      const queryParams = new URLSearchParams(content.query)
      const queryStr = queryParams.toString()
      url = `${baseUrl}?${queryStr}`
    }
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...content?.headers,
      },
      body: content?.body && JSON.stringify(content.body),
    })

    const body: Record<string, unknown> = await response.json()

    if (!response.ok) {
      throw new FetchErrorResponse({ status: response.status, body })
    }

    return body as T
  } catch (error) {
    console.error(error)
    throw error
  }
}
